export const numNew = "gte";
export default {numNew};